// Backend API Base URL configuration
const BASE_URL = process.env.REACT_APP_API_URL 
  ? (process.env.REACT_APP_API_URL.endsWith('/api') ? process.env.REACT_APP_API_URL : `${process.env.REACT_APP_API_URL}/api`)
  : "https://portfolio-backend-aphl.onrender.com/api";

export const getApiUrl = (endpoint) => {
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${BASE_URL}${cleanEndpoint}`;
};

export const fetchWithAuth = async (endpoint, options = {}) => {
  const token = localStorage.getItem("adminToken");
  
  const headers = {
    "Content-Type": "application/json",
    ...(options.headers || {})
  };

  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  const url = getApiUrl(endpoint);
  
  try {
    const response = await fetch(url, {
      ...options,
      headers
    });

    // If 401 Unauthorized, token might be expired
    if (response.status === 401) {
      // Clear token if invalid
      if (endpoint.includes('/admin/')) {
        localStorage.removeItem("adminToken");
        localStorage.removeItem("adminUser");
      }
    }

    return response;
  } catch (error) {
    console.error(`API Fetch Error [${endpoint}]:`, error);
    throw error;
  }
};
